/**
 * 权限模式
 */
export const PermissionModeEnum = {
  // back
  // 后端
  BACK: 'BACK',
  // route mapping
  // 路由映射
  ROUTE_MAPPING: 'ROUTE_MAPPING',
} as const;
export type PermissionModeEnum = (typeof PermissionModeEnum)[keyof typeof PermissionModeEnum];

// Route switching animation
// 路由切换动画
export const RouterTransitionEnum = {
  ZOOM_FADE: 'zoom-fade',
  ZOOM_OUT: 'zoom-out',
  FADE_SIDE: 'fade-slide',
  FADE: 'fade',
  FADE_BOTTOM: 'fade-bottom',
  FADE_SCALE: 'fade-scale',
} as const;
export type RouterTransitionEnum = (typeof RouterTransitionEnum)[keyof typeof RouterTransitionEnum];
